import Util from './common-tools'
const defaultDarkImg = require('../assets/image/default-dark.png')
const rectangleDarkImg = require('../assets/image/rectangle-dark.svg')
const defaultLightImg = require('../assets/image/default-light.png')
const rectangleLightImg = require('../assets/image/rectangle.svg')
  ; (function () {

    // 暗黑模式样式变量修改（支持扩展）
    const styles = {
      // base配置是body的基本样式，即基底背景色
      // base: ['#ffffff', '#181C24'], // 前面是亮色模式，后面是暗黑模式
      // 下面是自定义的变量
      '--background_common_2': ['#FFFFFF', '#181C24'],
      '--text_common_base_1': ['#323233', '#f2f2f2'],
      '--search-conten-bgc': ['#f0f0f0', '#21252D'],
      '--search-clear-icon': ['#c8c9cc', '#808080'],
      '--text_common_base_2': ['#646566', '#A6A6A6'],
      '--header-title-border': ['#eeeeee', '#343435'],
      '--green_common_2': ['#00C00E', '#39bf42'],
      '--text_common_base_3': ['#969799', '#808080'],
      '--seprator_line_common_light': ['#F2F3F5', '#29292A'],
      '--subject-col': ['#222', '#f2f2f2'],
      '--textarea-pl-col': ['#757575', '#808080'],
      '--red_common_2': ['#F54636', '#F66559'],
      '--list-wraper-name': ['#1d1d1d', '#f2f2f2'],
      '--background_common_1': ['#F7F8FA', '#0F131C'],
      '--sheet-item-bgc': ['#ffffff', '#21252D'],
      '--sheet-item-red': ['red', '#F66559'],
      '--lineClass-bgc': ['#ebedf0', '#343435'],
      '--background_alert_component': ['#ffffff', '#21252D'],
      '--btn-reload': ['#06CB44', '#13C94F'],
      '--detail-active-col': ['#ccc', '#595959'],
      '--active-bot': ['#565656', '#A6A6A6'],
      '--img-body-bgc': ['#f8f9fb', '#0F131C'],
      '--cancel-col': ['#1d1d1d', '#f2f2f2'],
      '--active-item': ['rgba(14, 46, 70,.05)', '#0F131C'],
      '--mod-col': ['#030303', '#f2f2f2'],
      '--mod-title-col': ['#1d1d1d', '#f2f2f2'],
      '--depart-col': ['#9A9A9A', '#808080'],
      '--border-col': ['#eaeff3', '#181C24'],
      '--option-bgc': ['#fff', '#21252D'],
      '--border-bottom-col': ['#efefef', '#29292A'],
      '--border-close-col': ['#dfdfdf', '#29292A'],
      '--body-bgc': ['transparent', '#0F131C'],
      '--background_common_search': ['#F5F5F5', '#21252D'],
      '--rectangle-img': [`url(${rectangleLightImg})`, `url(${rectangleDarkImg})`],
      '--default-img': [`url(${defaultLightImg})`, `url(${defaultDarkImg})`]
    }

    function changeLight() {
      console.warn('暗黑模式：', true)
      for (const key in styles) {
        if (Object.hasOwnProperty.call(styles, key)) {
          const element = styles[key]
          let value = element[0]
          document.documentElement.style.setProperty(key, value)
          if (key === 'base') {
            document.body.style.background = value
            document.documentElement.style.background = value
          }
        }
      }
    }
    function changeDark() {
      console.warn('暗黑模式：', true)
      for (const key in styles) {
        if (Object.hasOwnProperty.call(styles, key)) {
          const element = styles[key]
          let value = element[1]
          document.documentElement.style.setProperty(key, value)
          if (key === 'base') {
            document.body.style.background = value
            document.documentElement.style.background = value
          }
        }
      }
    }

    function setDarkTheme(theme) {
      // theme = "black"
      if (theme === 'black') {
        changeDark()
      } else {
        theme = 'light'
        changeLight()
      }
      window.$theme = theme
    }

    function getUATheme() {
      let theme = ''
      // 支持本地暗黑调试
      const regDebug = /\?theme=(\w+)/
      if (regDebug.test(location.href)) {
        theme = RegExp.$1.toLowerCase()
      }
      if (theme) {
        return theme
      }
      const ua = window.navigator.userAgent
      const reg = /;theme:(\w+)/
      if (reg.test(ua)) {
        theme = RegExp.$1.toLowerCase()
      }
      return theme
    }

    function darkTimer() {
      // 暗黑主题
      let theme = getUATheme()
      setDarkTheme(theme)
      // iOS监听主题切换
      Util.call('registerThemeStyleChange', {
        success: function (res) {
          setDarkTheme(res.data.theme)
        }
      })
    }

    darkTimer()
  })()
